import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/screen/place/detail/index.tsx");
